export const hasUpperAndLowerCase = (str: string) => {
  const hasUpperCase = /[A-Z]/.test(str) // Verifica se há letras maiúsculas
  const hasLowerCase = /[a-z]/.test(str) // Verifica se há letras minúsculas
  return hasUpperCase && hasLowerCase // Retorna true se ambas forem verdade
}

export const hasNumbers = (str: string) => {
  const hasNumber = /\d/.test(str) // Verifica se há pelo menos um número na string
  return hasNumber
}

export const hasSpecialCharacters = (str: string) => {
  const specialCharacterPattern = /[!@#$%^&*()_+\-={}[\]:;"'<>,.?/]/
  return specialCharacterPattern.test(str) // Retorna true se encontrar caracteres especiais
}
